"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridFooter = void 0;
var react_1 = __importDefault(require("react"));
var Pagination_1 = require("./Pagination");
var DataGridFooter = function (props) {
    return (react_1.default.createElement("div", { className: "row" },
        react_1.default.createElement("div", { className: "col mt-2" },
            "Showing rows ",
            props.rowsToSkip + 1,
            " to ",
            Math.min(props.rowsToSkip + props.rowsPerPage, props.totalRows),
            " of ",
            props.totalRows),
        props.totalRows / props.rowsPerPage > 1 ? (react_1.default.createElement("div", { className: "col mt-2 d-flex justify-content-end" },
            react_1.default.createElement(Pagination_1.PaginationProvider, __assign({}, props)))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.DataGridFooter = DataGridFooter;
//# sourceMappingURL=DataGridFooter.js.map